module.exports = __webpack_public_path__ + "static/img/feature_tree.a10e6d6f.png";